<template>
    <div>
        <Modal v-model="show"
            width="1200"
            :footer-hide="true"
            title="内部购销现售入库单编辑"
            class-name="vertical-center-modal"
            @on-visible-change="onShowChange">
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
                <Row :gutter="16">
                    <Col span="13">
                    <Card class="thin-card-title"
                        :padding="0"
                        :bordered="false"
                        :dis-hover="true">
                        <p slot="title">已绑定产品</p>
                        <search-card :form="productTable.searchForm"
                            :table-load-event="getProductTableRecords"
                            :table-search="productTable.tableSearch"
                            :col-span="8"
                            :search-btn-col-span="8" />

                        <Row :gutter="16">
                            <Col span="24">
                            <stand-pagination-table :columns="productTable.tableColumns"
                                :data="productTable.tableData"
                                :loading="productTable.tableLoading"
                                :autoHeight="true"
                                :table-search="productTable.tableSearch"
                                :table-load-event="getProductTableRecords"
                                @on-selection-change="onProductSelect" />
                            </Col>
                        </Row>

                        <Divider />
                        <Row :gutter="16">
                            <Col span="24">
                            <Button :disabled="productTable.selection.length === 0"
                                type="primary"
                                long
                                @click="onEntryProducts">添加所选</Button>
                            </Col>
                        </Row>
                    </Card>
                    </Col>

                    <Col span="11">
                    <Card class="thin-card-title"
                        :padding="0"
                        :bordered="false"
                        :dis-hover="true">
                        <p slot="title">入库产品</p>
                        <div slot="extra">
                            <Button type="error"
                                size='small'
                                class="btns"
                                icon="ios-send"
                                ghost
                                @click="onClickImport()">导入</Button>
                            <Button :disabled="entryTable.tableData.length === 0"
                                size="small"
                                class="btns"
                                type="primary"
                                :loading="entryTable.loading"
                                @click="onSubmit">提交入库</Button>
                        </div>

                        <Table :columns="entryTable.tableColumns"
                            size="small"
                            :loading="entryTable.loading"
                            :data="entryTable.tableData"
                            :border="true"
                            :stripe="true" />
                        <div style="font-size:16px;margin-top:10px;">
                            <span>总数量:{{entryTable.totalQuantity}}</span>
                            <span style="margin-left:10px;">总金额:{{entryTable.totalValue}}</span>
                        </div>
                    </Card>
                    </Col>
                </Row>
            </Card>
        </Modal>

        <Modal v-model="importModel.show"
            title="请选择要导入的文件"
            :mask-closable="false"
            @on-ok="onImportPlan"
            :loading="true"
            width=300>
            <div style="display:flex;justify-content: space-between;">
                <Upload :show-upload-list="false"
                    :action="UPLOAD_FILE_API"
                    :format="['xlsx']"
                    :on-success="handleSuccess"
                    :on-format-error="handleFormatError">
                    <Button icon="ios-cloud-upload-outline">选择文件</Button>
                </Upload>

                <Button icon="ios-cloud-download-outline"
                    @click="downloadImportTemplate()">下载模板</Button>
            </div>
            <div>{{importModel.fileName}}</div>
        </Modal>
    </div>

</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { singleImageRender } from '@/libs/tableRowImageRender';
import { currencyRender } from '@/libs/tableRowTimeRender';
import { formatDateString } from '@/libs/logic';
import { APPROVAL_YES } from '@/libs/baseModelFormat';
import { number2ThousandsFormat, numberToFixed } from '@/components/number-input/display-format';
import DecimalInput from '@/components/number-input/decimal-input';
import IntegerInput from '@/components/number-input/integer-input';
import {
    DEPARTMENT_TYPE_BINFEN,
    DEPARTMENT_TYPE_EXTERNAL
} from '@/view/system-management/department-management/DepartmentTypeDefine';

import { getAgentProductList } from '@/api/modules/product-management/product-management';
import { importAgentSaleProduct } from '@/api/modules/system-management/seedFarm-management';
import { saveCurSaleAgentWarehouseEntry } from '@/api/modules/warehouse-management/warehouseEntry';
import { getDepartmentList } from '@/api/modules/system-management/department-management';
import { DOWNLOAD_SERVER, UPLOAD_FILE_API } from '@/api/modules/files';

export default {
    name: 'CurSaleAgentWarehouseEntryEdit',
    components: {
        SearchCard,
        StandPaginationTable,
        DecimalInput,
        IntegerInput
    },
    data() {
        return {
            UPLOAD_FILE_API,
            show: false,
            DEPARTMENT_TYPE_EXTERNAL,
            DEPARTMENT_TYPE_BINFEN,
            departmentType: DEPARTMENT_TYPE_BINFEN,
            warehouseEntryFrom: {
                warehouseEntryRecordUuid: '',
                warehouseEntryRecordProject: '',
                warehouseEntryRecordContactNumber: '',
                warehouseEntryRecordBillCode: '',
                warehouseEntryRecordStatus: '',
                warehouseEntryRecordCreateAt: '',
                userPersonName: ''
            },
            ruleValidate: {
                warehouseEntryRecordProject: [{ required: true, message: ' ', trigger: 'blur' }]
            },
            productTable: {
                tableColumns: [
                    { title: '', type: 'selection', width: 40, align: 'center' },
                    { title: '产品编号', key: 'productCode', width: 80, align: 'center' },
                    { title: '名称', key: 'productName', width: 100, align: 'center' },
                    { title: '单位', key: 'unitName', width: 40, align: 'center' },
                    { title: '购销商', key: 'seedFarmName', width: 100, align: 'center' },
                    {
                        title: '现售入库价',
                        key: 'productAgentCurSalePrice',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, number2ThousandsFormat(params.row.productAgentCurSalePrice, 4, '￥'))
                            ]);
                        }
                    },
                    { title: '计划入库量', key: 'productAgentCurSalePlanQuantity', width: 80, align: 'center' },
                    { title: '累计入库量', key: 'productAgentCurSaleActualQuantity', width: 80, align: 'center' }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '名称', type: 'Input', value: '', name: 'productName', sql: 'like' },
                    { label: '产品编号', type: 'Input', value: '', name: 'productCode', sql: 'like' }
                ],
                selection: []
            },
            entryTable: {
                tableColumns: [
                    { title: '产品编号', key: 'productCode', width: 80, align: 'center' },
                    { title: '名称', key: 'productName', width: 100, align: 'center' },
                    // { title: '单价', key: 'productAgentCurSalePrice', width: 80, align: 'center' },
                    {
                        title: '入库单价',
                        key: 'productAgentCurSalePrice',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h(DecimalInput, {
                                props: {
                                    value: params.row.productAgentCurSalePrice,
                                    max: 1000000,
                                    precision: 2,
                                    readonly: params.row.productAgentProductSeedFarmCanChangePrice === 0
                                },
                                on: {
                                    change: newVal => {
                                        this.entryTable.tableData[params.index].productAgentCurSalePrice = newVal;
                                        let saleValue = numberToFixed(this.entryTable.tableData[params.index].warehouseEntryDetailAmount * newVal, 2);
                                        this.entryTable.tableData[params.index].productAgentCurSaleValue = saleValue;
                                        params.row.productAgentCurSaleValue = saleValue;
                                        this.calculateTotalImportAmount();
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: '入库数量',
                        key: 'warehouseEntryDetailAmount',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h(DecimalInput, {
                                props: {
                                    value: params.row.warehouseEntryDetailAmount,
                                    max: 1000000,
                                    precision: 0
                                },
                                on: {
                                    change: newVal => {
                                        this.entryTable.tableData[params.index].warehouseEntryDetailAmount = newVal;
                                        let saleValue = numberToFixed(this.entryTable.tableData[params.index].productAgentCurSalePrice * newVal, 2);
                                        this.entryTable.tableData[params.index].productAgentCurSaleValue = saleValue;
                                        params.row.productAgentCurSaleValue = saleValue;
                                        this.calculateTotalImportAmount();
                                    }
                                }
                            });
                        }
                    },
                    { title: '金额', key: 'productAgentCurSaleValue', width: 80, align: 'center' },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    on: {
                                        click: () => {
                                            this.onRemoveEntryProduct(params.index);
                                        }
                                    }
                                }, '删除')
                            ]);
                        }
                    }
                ],
                tableData: [],
                loading: false,
                totalQuantity: 0,
                totalValue: 0
            },
            departmentSource: [],
            deaprtmentOptions: [],
            importModel: {
                show: false,
                loading: false,
                fileWebName: '',
                fileName: ''
            }
        };
    },
    computed: {
        formatWarehouseEntryRecordCreateAt() {
            if (this.warehouseEntryFrom.warehouseEntryRecordCreateAt === '') {
                return '';
            }
            return formatDateString(this.warehouseEntryFrom.warehouseEntryRecordCreateAt);
        }
    },
    mounted() {

    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal() {
            this.show = true;
        },
        init() {
            this.entryTable.tableData = [];
            this.getProductTableRecords();
            this.getDepartmentSource();
        },

        calculateTotalImportAmount() {
            this.entryTable.totalQuantity = this.entryTable.tableData.map(e => {
                return e.warehouseEntryDetailAmount;
            }).reduce((total, num) => {
                return total + num;
            });

            this.entryTable.totalValue = this.entryTable.tableData.map(e => {
                return e.productAgentCurSaleValue;
            }).reduce((total, num) => {
                return total + num;
            });
        },

        handleSuccess(res, file) {
            this.importModel.fileWebName = res.data.fileList[0].fileUuid;
            this.importModel.fileName = res.data.fileList[0].fileName;
        },
        handleFormatError(file) {
            const str = this.format.join(', ');
            this.$Notice.warning({
                title: '文件格式错误',
                desc: '请选择 ' + str + ' 后缀的文件.'
            });
        },
        onClickImport() {
            this.importModel.fileName = '';
            this.importModel.fileWebName = '';
            this.importModel.show = true;
        },
        onImportPlan() {
            importAgentSaleProduct({ importFileName: this.importModel.fileWebName }).then(res => {
                this.importModel.show = false;
                if (res.code === 0) {
                    this.entryTable.tableData = res.data.importProducts;
                    this.calculateTotalImportAmount();
                    this.$Modal.success({
                        title: '导入成功',
                        content: ''
                    });
                }
            });
        },
        downloadImportTemplate() {
            let url = DOWNLOAD_SERVER + 'Import/template/agent_sale_entry_import_template.xlsx';
            this.$downLoadFile(url);
            // window.open(FILE_SERVER + "Import/template/agent_sale_entry_import_template.xlsx", "_blank");
        },

        getDepartmentSource() {
            const searchCondition = search.getSearchParams({ closeAllConditions: true });
            getDepartmentList(searchCondition).then(res => {
                if (res.code === 0) {
                    this.departmentSource = res.data.records;
                    this.onDepartmentChange();
                }
            });
        },
        getProductTableRecords(reset = false) {
            this.productTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.productTable.tableSearch);
            }

            // 强制设置已审核的过滤
            this.productTable.tableSearch.filters.enable = true;
            const approveFilterQuery = this.productTable.tableSearch.filters.conditions.find(f => f.name === 'productApproval');
            if (approveFilterQuery) {
                approveFilterQuery.value = APPROVAL_YES;
                approveFilterQuery.type = 'eq';
            }
            else {
                this.productTable.tableSearch.filters.conditions.push({
                    name: 'productApproval',
                    type: 'eq',
                    value: APPROVAL_YES
                });
            }

            getAgentProductList(this.productTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.productTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.productTable.tableSearch, res.data.filterRecordCount);
                }

                this.productTable.tableLoading = false;
            });
        },
        onProductSelect(selection) {
            this.productTable.selection = selection;
        },
        onEntryProducts() {
            if (this.productTable.selection.length === 0) {
                return;
            }

            const products = this.productTable.selection.filter(p => {
                return !this.entryTable.tableData.find(s => s.productUuid === p.productUuid);
            }).map(p => {
                return Object.assign(p, {
                    warehouseEntryDetailIsPublic: 1,
                    warehouseEntryDetailAmount: 0,
                    warehouseEntryDetailRemark: '',
                    warehouseProductStoreBatchPrice: 0,
                    productAgentCurSaleValue: 0
                });
            });

            this.entryTable.tableData.push(...products);
            this.calculateTotalImportAmount();
        },
        onRemoveEntryProduct(index) {
            this.entryTable.tableData.splice(index, 1);
            this.calculateTotalImportAmount();
        },
        onSubmit() {
            if (this.entryTable.tableData.length === 0) {
                this.$Message.error('请至少添加一个入库产品!');
                return;
            }

            const checkEmpty = this.entryTable.tableData.find(p => p.warehouseEntryDetailAmount === 0);
            if (checkEmpty) {
                this.$Message.error('所有产品必须设定 入库数量');
                return;
            }

            const submitData = Object.assign({}, this.warehouseEntryFrom);
            submitData.entryProducts = this.entryTable.tableData.map(p => {
                return {
                    warehouseEntryDetailRelateProductUuid: p.productUuid,
                    warehouseEntryDetailAmount: p.warehouseEntryDetailAmount,
                    warehouseEntryDetailPrice: p.productAgentCurSalePrice,
                    warehouseEntryDetailIsPublic: p.warehouseEntryDetailIsPublic,
                    warehouseEntryDetailRemark: ''
                };
            });

            this.$Modal.confirm({
                title: '确认提交入库？',
                content: '提交入库后，入库商品将进行自动结算，该操作无法撤回，请确认。',
                onOk: () => {
                    this.entryTable.loading = true;
                    saveCurSaleAgentWarehouseEntry(submitData).then(res => {
                        this.entryTable.loading = false;
                        if (res.code === 0) {
                            this.show = false;
                            this.$parent.init();
                            this.$Message.success('保存成功');
                        }
                    });
                }
            });


        },
        onDepartmentChange() {
            this.deaprtmentOptions = this.departmentSource.filter(d => d.departmentType === this.departmentType);
        }
    }
};
</script>

<style scoped>
</style>
